import { checkHealth } from '../services/api-client'
import { CLIENT_VERSION, SERVER_VERSION } from '../version'
import { el } from './ui/app-api'

/** Persistent release identity for QA: survives screen changes and cutscene overlays. */
export class BuildVersionBadge {
  readonly el: HTMLDivElement

  constructor() {
    this.el = el('div', {
      class: 'build-version',
      attrs: {
        'data-testid': 'build-version',
        'data-client-version': CLIENT_VERSION,
        'data-server-version': SERVER_VERSION,
        'data-server-status': 'checking',
        'aria-label': `Client ${CLIENT_VERSION}; server ${SERVER_VERSION}`,
      },
      text: this.label(SERVER_VERSION),
    })
    void this.refreshServerVersion()
  }

  private label(serverVersion: string): string {
    return `CLIENT v${CLIENT_VERSION} · SERVER v${serverVersion}`
  }

  private async refreshServerVersion(): Promise<void> {
    try {
      const health = await checkHealth()
      const serverVersion = typeof health.version === 'string' && health.version.trim()
        ? health.version.trim()
        : SERVER_VERSION
      this.el.dataset.serverVersion = serverVersion
      this.el.dataset.serverStatus = health.ok ? 'online' : 'offline'
      this.el.textContent = this.label(serverVersion)
      this.el.setAttribute('aria-label', `Client ${CLIENT_VERSION}; server ${serverVersion}`)
    } catch {
      // A standalone Vite build has no API beside it; retain the paired release number so the
      // badge remains useful during offline/dev rendering while exposing the connection state.
      this.el.dataset.serverVersion = SERVER_VERSION
      this.el.dataset.serverStatus = 'offline'
      this.el.textContent = this.label(SERVER_VERSION)
    }
  }
}
